module.exports = __webpack_public_path__ + "static/media/GU.851bfab2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/GU.svg
// module id = 2164
// module chunks = 7